import { onPageLoad } from '@/js/modules/page_load';
import { initOnboarding } from '@/js/modules/onboarding';

onPageLoad(() => {
  // Expose to window for usage in Floorplanner
  window.initOnboarding = window.initOnboarding || initOnboarding;
});
